// src/components/contact/Contact.js
import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faPhone, 
    faEnvelope, 
    faMapMarkerAlt,
    faClock
} from '@fortawesome/free-solid-svg-icons';

const Contact = () => {
    const contactInfo = [
        {
            icon: faPhone,
            title: 'Phone',
            details: ['+91 95351 50008', '080-26623007']
        },
        {
            icon: faEnvelope,
            title: 'Email',
            details: ['info@mediaassociation.co.in']
        },
        {
            icon: faMapMarkerAlt,
            title: 'Address',
            details: ['#65, 3rd Floor, SSR Archade', 'Gandhi Bazaar Main Road', 'Basavanagudi, Bangalore, Karnataka - 560004']
        }
    ];

    return (
        <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
            <Container>
                <Row className="mb-5">
                    <Col>
                        <h1 className="display-4 fw-bold text-center">Contact Us</h1>
                        <div className="divider mx-auto" style={{ width: '60px', height: '4px', background: 'linear-gradient(90deg, #0056b3, #007bff)', marginBottom: '1rem' }} />
                        <p className="text-center text-muted">We'd love to hear from you. Get in touch with us.</p>
                    </Col>
                </Row>

                <Row>
                    {/* Contact Information Cards */}
                    <Col lg={4} className="mb-4">
                        {contactInfo.map((info, index) => (
                            <Card key={index} className="mb-3 shadow-sm border-0 hover-shadow transition">
                                <Card.Body>
                                    <div className="d-flex align-items-start">
                                        <div className="contact-icon me-3">
                                            <FontAwesomeIcon 
                                                icon={info.icon} 
                                                size="2x" 
                                                className="text-primary"
                                            />
                                        </div>
                                        <div>
                                            <h6 className="fw-bold mb-1">{info.title}</h6>
                                            {info.details.map((detail, idx) => (
                                                <p key={idx} className="text-muted mb-0 small">{detail}</p>
                                            ))}
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        ))}
                        
                        {/* Business Hours Card */}
                        <Card className="shadow-sm border-0">
                            <Card.Body>
                                <div className="d-flex align-items-start">
                                    <div className="contact-icon me-3">
                                        <FontAwesomeIcon 
                                            icon={faClock} 
                                            size="2x" 
                                            className="text-primary"
                                        />
                                    </div>
                                    <div>
                                        <h6 className="fw-bold mb-1">Business Hours</h6>
                                        <p className="text-muted mb-0 small">Monday - Friday: 9:00 AM - 6:00 PM</p>
                                        <p className="text-muted mb-0 small">Saturday: 10:00 AM - 2:00 PM</p>
                                        <p className="text-muted mb-0 small">Sunday: Closed</p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* Google Map */}
                    <Col lg={8}>
                        <Card className="shadow-sm border-0 overflow-hidden">
                            <Card.Body className="p-0">
                                <div className="map-container">
                                    <iframe 
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4652.919033321408!2d77.57019869999999!3d12.946082200000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15f300c74f31%3A0xe4306e239ecbdec4!2sKarnataka%20Police%20TV!5e1!3m2!1sen!2sin!4v1788856434674!5m2!1sen!2sin" 
                                        width="100%" 
                                        height="450" 
                                        style={{ border: 0, display: 'block' }} 
                                        allowFullScreen 
                                        loading="lazy" 
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        title="Karnataka Police TV Location"
                                        className="google-map"
                                    />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Optional: Get in Touch CTA */}
                <Row className="mt-5">
                    <Col>
                        <Card className="bg-primary text-white border-0 shadow-lg">
                            <Card.Body className="p-4 text-center">
                                <h4 className="fw-bold mb-3">
                                    <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                                    Have Questions?
                                </h4>
                                <p className="mb-3">
                                    Reach out to us via phone, email, or visit our office. We're here to help!
                                </p>
                                <div className="d-flex flex-wrap justify-content-center gap-3">
                                    <a href="tel:+919535150008" className="btn btn-light rounded-pill px-4">
                                        <FontAwesomeIcon icon={faPhone} className="me-2" />
                                        Call Us
                                    </a>
                                    <a href="mailto:info@mediaassociation.co.in" className="btn btn-outline-light rounded-pill px-4">
                                        <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                                        Email Us
                                    </a>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>

            {/* Custom CSS */}
            <style jsx>{`
                .hover-shadow {
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                }
                .hover-shadow:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 8px 20px rgba(0,0,0,0.1) !important;
                }
                .transition {
                    transition: all 0.3s ease;
                }
                .map-container {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    min-height: 450px;
                }
                .google-map {
                    width: 100%;
                    height: 100%;
                    min-height: 450px;
                }
                @media (max-width: 768px) {
                    .map-container {
                        min-height: 300px;
                    }
                    .google-map {
                        min-height: 300px;
                    }
                }
            `}</style>
        </section>
    );
};

export default Contact;